import { render, staticRenderFns } from "./WhatNeedToPickup.vue?vue&type=template&id=6f97f601&scoped=true&"
import script from "./WhatNeedToPickup.vue?vue&type=script&lang=js&"
export * from "./WhatNeedToPickup.vue?vue&type=script&lang=js&"
import style0 from "./WhatNeedToPickup.vue?vue&type=style&index=0&id=6f97f601&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f97f601",
  null
  
)

export default component.exports